import { IFacet } from "shared-services";
import { TFunction } from "i18n";

export enum IContractStatus {
  current = "current",
  renewing = "renewing",
  expired = "expired",
}

export function getContractStatus(t: TFunction): IFacet[] {
  return Object.values(IContractStatus).map((status, index) => ({
    id: status,
    name: t(`common:search.filters.contractStatus.${status}`),
    code: status,
    orderKey: index,
  }));
}
